function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, openBlock, createElementBlock, normalizeClass, unref, createElementVNode, normalizeStyle } from 'vue';
import { alphaSliderProps } from '../props/alpha-slider.mjs';
import { useAlphaSlider, useAlphaSliderDOM } from '../composables/use-alpha-slider.mjs';
import _export_sfc from '../../../../_virtual/plugin-vue_export-helper.mjs';
const COMPONENT_NAME = "ElColorAlphaSlider";
const __default__ = defineComponent({
  name: COMPONENT_NAME
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: alphaSliderProps,
  setup(__props, _ref) {
    let expose = _ref.expose;
    const props = __props;
    const _useAlphaSlider = useAlphaSlider(props),
      bar = _useAlphaSlider.bar,
      thumb = _useAlphaSlider.thumb,
      handleDrag = _useAlphaSlider.handleDrag,
      handleClick = _useAlphaSlider.handleClick;
    const _useAlphaSliderDOM = useAlphaSliderDOM(props, {
        bar,
        thumb,
        handleDrag
      }),
      rootKls = _useAlphaSliderDOM.rootKls,
      barKls = _useAlphaSliderDOM.barKls,
      barStyle = _useAlphaSliderDOM.barStyle,
      thumbKls = _useAlphaSliderDOM.thumbKls,
      thumbStyle = _useAlphaSliderDOM.thumbStyle,
      update = _useAlphaSliderDOM.update;
    expose({
      update,
      bar,
      thumb
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(rootKls))
      }, [createElementVNode("div", {
        ref_key: "bar",
        ref: bar,
        class: normalizeClass(unref(barKls)),
        style: normalizeStyle(unref(barStyle)),
        onClick: _cache[0] || (_cache[0] = function () {
          return unref(handleClick) && unref(handleClick)(...arguments);
        })
      }, null, 6), createElementVNode("div", {
        ref_key: "thumb",
        ref: thumb,
        class: normalizeClass(unref(thumbKls)),
        style: normalizeStyle(unref(thumbStyle))
      }, null, 6)], 2);
    };
  }
}));
var AlphaSlider = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "alpha-slider.vue"]]);
export { AlphaSlider as default };